/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cta_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Experience the future of Minecraft server authentication.`)
};

const zh_hans1_cta_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`体验 Minecraft 服务器身份验证的未来。`)
};

const zh_hant1_cta_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`體驗 Minecraft 伺服器身分驗證的未來。`)
};

const fr_cta_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrez l’avenir de l’authentification sur serveur Minecraft.`)
};

const de_cta_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erlebe die Zukunft der Minecraft-Server-Authentifizierung.`)
};

const ja_cta_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft サーバー認証の未来を体験しましょう。`)
};

const ko_cta_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 서버 인증의 미래를 경험해 보세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cta_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cta_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cta_desc", locale)
	if (locale === "en") return en_cta_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_cta_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_cta_desc(inputs)
	if (locale === "fr") return fr_cta_desc(inputs)
	if (locale === "de") return de_cta_desc(inputs)
	if (locale === "ja") return ja_cta_desc(inputs)
	return ko_cta_desc(inputs)
};